var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#479ed5;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,15C3.5,15,0,9.677,0,7.5S3.5,0,10,0,20,5.323,20,7.5,16.5,15,10,15ZM10,1.667c-5.653,0-8.333,4.678-8.333,5.833S4.347,13.333,10,13.333,18.333,8.655,18.333,7.5,15.653,1.667,10,1.667Zm0,10A4.167,4.167,0,1,1,14.167,7.5,4.171,4.171,0,0,1,10,11.667ZM10,5a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,10,5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.dbdc47918368d91ca7283303979e3221.svg";
export { ForwardRef as ReactComponent };